import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    version: '1.00',
    uuid: '',
    menuadmin: true,
    idusuario: 0,
    usuario: '',
    nombre: '',
    perfil: '',
    fechaServicio: '',
    fechaS: '',
    horaS: '',
    tipoS: '',
    lugarServicio: '',
    barraServicio: {},
    regTecho: {},
    regRodapie: {},
    regPuerta: {},
    regMarco: {},
    logueado: false,
    essocio: false,
    email: '',
    cp: '',
    vm: null,
    cuando: 0,   //Cuando tipo=1 Fontanería
    cuando2: 0,  //Cuando tipo=2 Persianas
    cuando3: 0,  //Cuando tipo=3 Electricidad
    cuando4: 0,  //Cuando tipo=4 Pintura
    cuando5: 0,  //Cuando tipo=5 Cerrajería
    cuando6: 0,  //Cuando tipo=6 Manitas
    geoPais: '',
    geoCiudad: '',
    geoPaisCod: '',
    geoLat: '',
    geoLon: '',
    geoIP: '',
    geoCP: '',
    busqOrig: '',
    busqIA: '',
    busqClave: '',
    busqServicio: '',
    busqServicios: [],  //Servicio tipo=1 Fontanería
    busqServicios2: [], //Servicio tipo=2 Persianas
    busqFamilia: '',
    elecActividad: '',
    txtActividad: '',
    elecReparacion: '',
    servImporte: 0.00,
    servImporteUrgente: 0.00,
    servImporteSocio: 0.00,
    servImpPrimeraHora: 0.00,
    servImporteUrgenteNormal: 0.00,
    servImporteUrgenteEspecial: 0.00,
    nivelUrgencia: 0,  //0 si es horario normal, 1 si es urgente, 2 si es urgente especial
    servImp: 0.00,
    servImpUrgente: 0.00,
    servImpSocio: 0.00,
    salidaImporte: 0.00,
    servImportes: [],   //Importe tipo=1 Fontanería
    servImportes2: [],  //Importe tipo=2 Persianas
    ultimaFamilia: 0,   //Ultima familia seleccionada 1 Fontanería, 2 Persianas, etc.
    idunico: '',
    esgestor: 0,
    sociopagado: 0,
    sociohasta: '',
    aPagar: 0,
    idPedido: 0,
    festivos: {},
    codComun: '00',
    confirmasocio: false,
    fechaserv1: "",
    fechaserv2: "",
    fechaserv3: "",
    fechaserv4: "",
    fechaserv5: "",
    fechaserv6: "",
    fechaserv7: "",
    fechaserv8: "",
    fechaserv9: "",
    fechaserv10: "",
    fechaserv11: "",
    fechaserv12: "",
    fechaserv13: "",
    fechaserv14: "",
    fechaserv15: "",
    fechaserv16: "",
    fechaserv17: "",
    fechaserv18: "",
    fechaserv19: "",
    fechaserv20: "",
    fechaserv21: "",
    fechaserv22: "",
    fechaserv23: "",
    fechaserv24: "",
    fechaserv25: "",
    fechaserv26: "",
    imptot: 0,
    imptotsocio: 0,
    ayudaenservicio: 0,
    ayudabusq: '',
    ayudaact: '',

  },
  mutations: {
  	modifUuid(state, payload) {
  		state.uuid = payload
  	},
    modifMenuadmin(state, payload) {
      state.menuadmin = payload
    }
  },
  getters: {
  	dameUuid(state) {
  		return state.uuid
  	},
    dameMenuadmin(state) {
      return state.menuadmin
    },
    verVersion(state) {
      return state.version
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js